import axios from 'axios';
import { urlApiAsesoria } from '../Config/baseUrl';
import {
  IFinalizarRutina,
  IObtenerMisRutinas,
  IObtenerMisRutinasTotal,
  IObtenerPesos,
  IObtenerPesosConDropset,
  IObtenerRutinaDeEjercicio,
  IReemplazarEjercicio,
  SerieParaAPI,
} from '../Interfaces/IMisRutinas';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const obtenerMisRutinas = (data: IObtenerMisRutinas) => {
  return axios.post(urlApiAsesoria + 'fit4/distribucion', data, config);
};

export const obtenerRutinaDeEjercicio = (data: IObtenerRutinaDeEjercicio) => {
  return axios.post(urlApiAsesoria + 'fit4/obtenerEjerciciosv2', data, config);
};

export const guardarActualizarPesos = (data: SerieParaAPI[]) => {
  return axios.post(urlApiAsesoria + 'fit4/guardarPesosPorSerie', data, config);
};

export const guardarPesosConDropset = (data: SerieParaAPI[]) => {
  return axios.post(urlApiAsesoria + 'fit4/guardarPesosPorSerieConDropset', data, config);
};

export const obtenerPesos = (data: IObtenerPesos) => {
  return axios.post(urlApiAsesoria + 'fit4/obtenerPesosPorEjercicio', data, config);
};

export const obtenerPesosConDropset = (data: IObtenerPesosConDropset) => {
  return axios.post(
    urlApiAsesoria + 'fit4/obtenerPesosPorEjercicioConDropset',
    data,
    config,
  );
};

export const finalizarRutina = (data: IFinalizarRutina) => {
  return axios.post(urlApiAsesoria + 'fit4/finalizarRutinaFit4', data, config);
};

export const reemplazarEjercicio = (data: IReemplazarEjercicio) => {
  return axios.post(urlApiAsesoria + 'fit4/reemplazarEjercicio', data, config);
};

export const obtenerMisRutinasTotal = (data: IObtenerMisRutinasTotal) => {
  return axios.post(urlApiAsesoria + 'fit4/distribucionTotal', data, config);
};
